import { createSelector } from 'reselect';

const localidadesEntregaReducerDataSelector = state => state.localidadesEntregaReducer.getIn(["data"]).toJS();

export const localidadesEntregaDataSelector = createSelector(
    localidadesEntregaReducerDataSelector, (dataField) => {
        return {
            localidades: dataField.localidades || []
        };
    }
);

export const localidadesEntregaEditSelector = createSelector(
    localidadesEntregaReducerDataSelector, (dataField) => {
        return {
            localidad: {
                ...dataField.localidadEdit,
            }
        };
    }
);